import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { SignOut, Car, Wrench, Receipt } from "@phosphor-icons/react";

import PojazdyListTab from "../components/admin/PojazdyListTab";
import NaprawyTab from "../components/admin/NaprawyTab";
import UroTab from "../components/admin/UroTab";

export default function MechanicDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("pojazdy");

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Wrench className="w-6 h-6 text-emerald-600" weight="duotone" />
            <div>
              <h1 className="text-base font-bold text-slate-800 leading-tight">
                AODEX — Panel mechanika
              </h1>
              <div className="text-xs text-slate-500">
                {user?.name || "Mechanik"}
              </div>
            </div>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-3 py-2 text-sm bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-md transition-colors"
            data-testid="mechanic-logout-btn"
          >
            <SignOut className="w-4 h-4" />
            Wyloguj
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Tab switcher */}
        <div className="mb-6 flex gap-2 border-b border-slate-200">
          <button
            onClick={() => setTab("pojazdy")}
            className={`py-3 px-6 text-sm font-semibold border-b-2 -mb-px transition-colors flex items-center gap-2 ${
              tab === "pojazdy"
                ? "border-emerald-600 text-emerald-600"
                : "border-transparent text-slate-600 hover:text-slate-900"
            }`}
            data-testid="mechanic-tab-pojazdy"
          >
            <Car className="w-5 h-5" />
            Pojazdy
          </button>
          <button
            onClick={() => setTab("naprawy")}
            className={`py-3 px-6 text-sm font-semibold border-b-2 -mb-px transition-colors flex items-center gap-2 ${
              tab === "naprawy"
                ? "border-emerald-600 text-emerald-600"
                : "border-transparent text-slate-600 hover:text-slate-900"
            }`}
            data-testid="mechanic-tab-naprawy"
          >
            <Wrench className="w-5 h-5" />
            Naprawy
          </button>
          <button
            onClick={() => setTab("uro")}
            className={`py-3 px-6 text-sm font-semibold border-b-2 -mb-px transition-colors flex items-center gap-2 ${
              tab === "uro"
                ? "border-emerald-600 text-emerald-600"
                : "border-transparent text-slate-600 hover:text-slate-900"
            }`}
            data-testid="mechanic-tab-uro"
          >
            <Receipt className="w-5 h-5" />
            URO
          </button>
        </div>

        {tab === "pojazdy" && <PojazdyListTab readOnly />}
        {tab === "naprawy" && <NaprawyTab />}
        {tab === "uro" && <UroTab />}
      </main>
    </div>
  );
}
